/* istanbul ignore file */

/**
 *
 * Asynchronously loads the component for JobLogDeliveryPortfolioSection
 *
 */

import { lazyLoad } from 'utils/loadable';

const JobLogDeliveryPortfolioSection = lazyLoad(
  () => import('./index'),
  module => module.JobLogDeliveryPortfolioSection,
);

export default JobLogDeliveryPortfolioSection;
